// import './wydr';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter as Router } from 'react-router-dom'
import {Provider as ReduxProvider } from 'react-redux'
import store from './redux/store';
import './fonts/Roboto-Regular.ttf'; 

ReactDOM.render(
    <ReduxProvider store={store} >
        <Router>
            <App />
        </Router>
    </ReduxProvider>
    , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
